import { createFolderActionTypes } from './Constants';
import { folderDetailsActionTypes } from '../../../pages/folderDetails/Constants';
import { listsActionTypes } from '../../../pages/lists/Constants';

const initialState = {
	error: '',
	loading: false,
	open: false,
	edit: false,
	folderTitle: '',
	folderShared: true,
	folderId: null,
	noRedirect: false,
	openFrom: 'profile',
};

export default function createFolderReducer(state = initialState, action) {
	const { type, payload } = action;
	const { open, options } = payload || {};

	switch (type) {
		case createFolderActionTypes.TOGGLE_CREATE_FOLDER_MODAL:
			const props = open
				? { open: true }
				: {
						error: '',
						loading: false,
						open: false,
						edit: false,
						folderTitle: '',
						folderShared: true,
						folderId: null,
						id: null,
						noRedirect: false,
				  };
			return {
				...state,
				error: '',
				loading: false,
				...props,
			};

		case createFolderActionTypes.HANDLE_CREATE_FOLDER_MODAL:
			return {
				...state,
				...options,
			};

		case folderDetailsActionTypes.UPDATE_FOLDER_REQUEST:
		case listsActionTypes.CREATE_FOLDER_REQUEST:
			return {
				...state,
				loading: true,
			};

		case folderDetailsActionTypes.UPDATE_FOLDER_SUCCESS:
		case folderDetailsActionTypes.UPDATE_FOLDER_ERROR:
		case folderDetailsActionTypes.CREATE_FOLDER_SUCCESS:
		case folderDetailsActionTypes.CREATE_FOLDER_ERROR:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
